import React, { useEffect, useRef, forwardRef, useImperativeHandle } from 'react';


const CustomLargeTextCellEditor = forwardRef((props, ref) => {
  const textAreaRef = useRef(null);

  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.focus();
      textAreaRef.current.select();
    }
  }, []);

  useImperativeHandle(ref, () => ({
    getGui() {
      return textAreaRef.current;
    },
    afterGuiAttached() {
      if (textAreaRef.current) {
        textAreaRef.current.focus();
        textAreaRef.current.select();
      }
    },
    getValue() {
      return textAreaRef.current.value;
    },
    isPopup() {
      return true;
    },
  }));

  return (
    <textarea
      ref={textAreaRef}
      rows={20}
      cols={50}
      defaultValue={props.value}
      style={{ width: '100%', height: '100%' }}
    />
  );
});

export default CustomLargeTextCellEditor;
